import React, { useEffect, useState, useRef, memo } from 'react';
import { Users, CheckCircle2, XCircle, TrendingUp, ShieldCheck, Award, Star } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { VideoPlayer } from '../components/VideoPlayer';
import { BonusCarousel } from '../components/BonusCarousel';
import { FAQSection } from '../components/FAQSection';
import { ReviewForm } from '../components/ReviewForm';
const ASSETS = {
  video: 'https://cdn.magicpatterns.com/uploads/t9VALvqSdaJ3PtBshLCcD7/MOTO LOGIC PRO(8)(1).mov',
  logo: 'https://cdn.magicpatterns.com/uploads/3vx95Mfcz4QZiHvjJtgYTr/capture_260217_231741.png',
  solutionImage: 'https://cdn.magicpatterns.com/uploads/htT1XwFguDbPtuDk86v4wu/unnamed_(7).jpg',
  mercadoPago: 'https://cdn.magicpatterns.com/uploads/cK52aAb7RSGa6wHixwE7L2/mercadopago2.jpg',
  mainProduct: 'https://cdn.magicpatterns.com/uploads/dfEDjVGJrHSHdi25jjRyxU/a-photorealistic-product-photograph-base_KJExYIC7T7ezSQAcBnxoCA_KpTGN4p-TgiDTGFU-s-_KA_hd.png',
  compraSegura: 'https://cdn.magicpatterns.com/uploads/rqZ3wv9AeoifUcgoSYyxoy/safe-purchase-7779878_1280.png',
  garantia: 'https://cdn.magicpatterns.com/uploads/6GVXh72hXpk5P6QipNEBqh/Selo-de-Garantia-de-7-Dias-PNG-Transparente-Sem-Fundo-1.png'
};
const PURCHASE_LINK = 'https://pay.hotmart.com/L97696976S?off=s7n8832j&checkoutMode=10';
const ALL_TESTIMONIALS = [{
  name: 'Javier M.',
  text: 'che muy bueno el curso, me sirvio una banda para empezar con el service de mi wave. se re entiende.'
}, {
  name: 'Lucas R.',
  text: 'Pensé que iba a ser mas dificil pero con los videos se entiende al toque. lo recomiendo de una.'
}, {
  name: 'Esteban D.',
  text: 'Muy buena la data de la parte electrica, ningun mecanico de mi barrio te lo explica tan claro.'
}, {
  name: 'Matías S.',
  text: 'lo empece hace 1 semana y ya le arregle el embrague a un vecino, ya recupere un poco de la inversión jaja.'
}, {
  name: 'Roberto F.',
  text: 'Espectacular, el manual pdf que viene de regalo es clave para tenerlo a mano en el taller.'
}, {
  name: 'Nicolás G.',
  text: 'alta data tiran en el grupo de alumnos, me sacaron una duda con un burro de arranque al toque.'
}, {
  name: 'Facundo L.',
  text: 'estaba entre este y otro pero me decidi por este x la logica de taller y no me arrepiento, es otra cosa.'
}, {
  name: 'Gonzalo P.',
  text: 'Muy completo el curso. Yo no sabia ni cambiar una bujia y ahora ya estoy desarmando un motor 150.'
}, {
  name: 'Martín C.',
  text: 'Lo mejor es que podes ver los videos mil veces, yo me re trabo con la inyeccion pero ahora ya le agarre la mano.'
}, {
  name: 'Diego A.',
  text: 're bien explicado todo, se nota q saben un montón los profes. 10 de 10.'
}, {
  name: 'Ramiro T.',
  text: 'me sirvió mucho para mi emprendimiento, aca en el interior faltan mecanicos asi q tengo bocha de laburo.'
}, {
  name: 'Sebastián V.',
  text: 'Sinceramente me sorprendio la calidad de los videos, se ve todo perfecto.'
}, {
  name: 'Pablo H.',
  text: 'al principio dudaba de pagar por internet pero el acceso fue automatico, al minuto ya estaba viendo las clases.'
}, {
  name: 'Tomás B.',
  text: 'Che el bono de los diagramas es una masa, me salvo la vida con una instalacion electrica de una motomel.'
}, {
  name: 'Agustín N.',
  text: 'lo recomiendo para los que recien arrancan, te explican paso a paso sin vueltas.'
}, {
  name: 'Federico J.',
  text: 'todo joya, ya voy por la mitad del curso y aprendi mas q en 2 años mirando youtube.'
}, {
  name: 'Carlos W.',
  text: 'buenisimo el curso, muy practico todo. saludos desde cordoba!'
}, {
  name: 'Leandro K.',
  text: 'Lo compre ayer y ya me vi como 20 clases, te engancha xq es pura practica.'
}, {
  name: 'Hernán Q.',
  text: 'Faltaba un curso asi en argentina, bien criollo y directo al grano para ganar plata.'
}, {
  name: 'Ignacio Z.',
  text: 'Una maravilla como explican la parte de transmision, me quedo clarisimo.'
}, {
  name: 'Andrés O.',
  text: 'los manuales q vienen son un golazo, los tengo en el celu y los miro mientras laburo en la moto.'
}, {
  name: 'Santiago E.',
  text: 'excelente inversion, ya me ahorre banda de plata haciendo yo mismo el mantenimiento.'
}, {
  name: 'Damián U.',
  text: 'me encanto la parte de herramientas caseras, te enseñan a no gastar de mas al principio.'
}, {
  name: 'Maximiliano I.',
  text: 'Muy copado el soporte por telegram, te contestan todo.'
}, {
  name: 'Cristian Y.',
  text: 'le doy 5 estrellas xq es real lo de la logica de taller, te cambia la forma de ver el motor.'
}, {
  name: 'Emiliano X.',
  text: 'Al toque me llego el mail, ya soy alumno y estoy re manija con las clases.'
}, {
  name: 'Valentín R.',
  text: 'gracias por la buena onda, se nota que quieren que aprendamos de verdad.'
}, {
  name: 'Lautaro D.',
  text: 'muy bueno para salir del paso con reparaciones rapidas y ganar unos pesos extra.'
}, {
  name: 'Joaquín F.',
  text: 'La verdad q vale cada centavo, no duden si les gustan las motos.'
}, {
  name: 'Thiago M.',
  text: 'un antes y un despues este curso, ahora ya se lo que estoy haciendo cuando toco el motor.'
}];
export function LandingPage() {
  const [spotsLeft, setSpotsLeft] = useState(9);
  const [viewers, setViewers] = useState(142);
  const [showHeader, setShowHeader] = useState(false);
  const heroRef = useRef<HTMLDivElement>(null);
  const [currentDate, setCurrentDate] = useState('');
  const [visibleCount, setVisibleCount] = useState(5);
  useEffect(() => {
    const interval = setInterval(() => {
      setSpotsLeft(prev => prev > 3 ? prev - 1 : 3);
    }, 15000);
    const viewerInterval = setInterval(() => {
      setViewers(prev => prev + Math.floor(Math.random() * 5) - 2);
    }, 5000);
    const handleScroll = () => {
      if (heroRef.current) {
        const heroBottom = heroRef.current.getBoundingClientRect().bottom;
        setShowHeader(heroBottom < 0);
      }
    };
    window.addEventListener('scroll', handleScroll);
    const date = new Date();
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    };
    setCurrentDate(date.toLocaleDateString('es-AR', options).toUpperCase());
    return () => {
      clearInterval(interval);
      clearInterval(viewerInterval);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const scrollToOffer = () => {
    const element = document.getElementById('offer-section');
    if (element) element.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const loadMoreComments = () => {
    setVisibleCount(prev => Math.min(prev + 5, ALL_TESTIMONIALS.length));
  };
  return <div className="min-h-screen bg-slate-950 text-slate-200 font-sans selection:bg-orange-500/30" data-id="element-70">
      {/* STICKY HEADER - Square logo, no title text */}
      <header className={`fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-b border-blue-500/50 py-3 px-4 transition-transform duration-300 ${showHeader ? 'translate-y-0' : '-translate-y-full'}`} data-id="element-71">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-72">
          <img src={ASSETS.logo} alt="Moto Logic Pro" className="h-10 w-auto" data-id="element-73" />
          <Button size="sm" onClick={scrollToOffer} className="text-xs md:text-sm" data-id="element-74">
            VER OFERTA
          </Button>
        </div>
      </header>

      {/* 1. HERO SECTION */}
      <section ref={heroRef} className="relative pt-8 pb-12 px-0 md:px-6 lg:px-8 overflow-hidden" data-id="element-75">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[500px] bg-orange-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-76" />

        <div className="max-w-5xl mx-auto text-center relative z-10 px-4" data-id="element-77">
          <p className="text-slate-300 font-medium text-xs md:text-sm uppercase tracking-widest mb-6" data-id="element-78">
            7 MILLONES DE MOTOS EN ARGENTINA BUSCAN UN MECÁNICO DE CONFIANZA. SÉ
            VOS EL PRÓXIMO
          </p>

          {/* H1 - Orange vibrant theme */}
          <div className="flex flex-col items-center gap-1 md:gap-2 mb-4 md:mb-8 leading-none" data-id="element-79">
            <span className="text-white text-2xl md:text-4xl font-bold tracking-tight" data-id="element-80">
              CONVERTÍ TU PASIÓN EN UNA
            </span>
            <span className="text-orange-500 text-4xl md:text-7xl font-black tracking-tighter uppercase" style={{
            textShadow: '0 0 40px rgba(249,115,22,0.4)'
          }} data-id="element-81">
              FÁBRICA DE INGRESOS
            </span>
            <span className="text-white text-2xl md:text-4xl font-bold tracking-tight mt-1 md:mt-2" data-id="element-82">
              CON EL SISTEMA
            </span>
            <span className="text-orange-500 text-4xl md:text-7xl font-black tracking-tighter uppercase" style={{
            textShadow: '0 0 40px rgba(249,115,22,0.4)'
          }} data-id="element-83">
              MOTO LOGIC PRO
            </span>
          </div>

          {/* Video */}
          <div className="w-full md:max-w-4xl mx-auto -mx-4 md:mx-auto mb-4 shadow-2xl shadow-orange-500/10" data-id="element-84">
            <VideoPlayer src={ASSETS.video} data-id="element-85" />
          </div>

          <p className="text-lg md:text-xl text-slate-300 font-medium mb-8 max-w-3xl mx-auto leading-relaxed px-4" data-id="element-86">
            No solo vas a arreglar motos; vas a aprender la{' '}
            <strong className="text-white" data-id="element-87">Lógica de Taller</strong> para
            diagnosticar cualquier falla en segundos. La salida laboral que
            buscás está a un clic de distancia.
          </p>

          <div className="px-4" data-id="element-88">
            <Button size="xl" fullWidth className="max-w-md mx-auto shadow-orange-500/25" onClick={scrollToOffer} data-id="element-89">
              QUIERO ACCEDER A MOTO LOGIC PRO AHORA
            </Button>
          </div>
        </div>
      </section>

      {/* 2. PAIN POINTS */}
      <section className="py-20 bg-slate-900 px-4" data-id="element-90">
        <div className="max-w-4xl mx-auto" data-id="element-91">
          <div className="text-center mb-12" data-id="element-92">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 uppercase" data-id="element-93">
              ¿Te pasa que amás las motos pero no te animás a dar el siguiente
              paso?
            </h2>
            <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-94">
              Sabemos que te apasiona el ruido del motor. Que te gusta meter
              mano. Pero también sabemos qué es lo que te detiene para empezar a
              vivir de esto:
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-95">
            {['El miedo a desarmar algo y no saber cómo volver a armarlo.', 'Sentir que te faltan años de estudio o herramientas carísimas para arrancar.', 'La inseguridad de no saber cuánto cobrar o cómo conseguir tus primeros clientes.'].map((pain, idx) => <Card key={idx} className="p-6 border-red-900/30 bg-red-950/10 hover:bg-red-950/20 transition-colors" data-id="element-96">
                <div className="flex flex-col items-center text-center gap-4" data-id="element-97">
                  <XCircle className="w-12 h-12 text-red-500" data-id="element-98" />
                  <p className="font-medium text-slate-200" data-id="element-99">{pain}</p>
                </div>
              </Card>)}
          </div>

          <div className="text-center bg-slate-800/50 p-8 rounded-2xl border border-slate-700" data-id="element-100">
            <p className="text-xl font-medium text-white" data-id="element-101">
              <span className="text-orange-500 font-bold" data-id="element-102">MOTO LOGIC PRO</span>{' '}
              nació para eliminar esas barreras. Te damos la seguridad técnica
              para que dejes de ser un aficionado y te conviertas en el
              profesional que tu zona está necesitando hoy mismo.
            </p>
          </div>
        </div>
      </section>

      {/* 3. OPPORTUNITY */}
      <section className="py-20 px-4" data-id="element-103">
        <div className="max-w-6xl mx-auto" data-id="element-104">
          <h2 className="text-3xl md:text-5xl font-bold text-white text-center mb-16 uppercase" data-id="element-105">
            ¿Por qué la mecánica es tu mejor oportunidad en Argentina?
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-106">
            {[{
            icon: <TrendingUp className="w-8 h-8" data-id="element-107" />,
            title: 'DEMANDA INAGOTABLE',
            desc: 'La moto es el principal medio de transporte y trabajo en el país. El flujo de clientes es constante y masivo.'
          }, {
            icon: <ShieldCheck className="w-8 h-8" data-id="element-108" />,
            title: 'NEGOCIO RESISTENTE',
            desc: 'En contextos económicos difíciles, la gente prioriza reparar su vehículo antes que comprar uno nuevo. Tu trabajo siempre es prioridad.'
          }, {
            icon: <Award className="w-8 h-8" data-id="element-109" />,
            title: 'VALOR POR DIAGNÓSTICO',
            desc: "Lo que más se paga hoy no es 'apretar tornillos', es saber por qué falla la moto. El que diagnostica rápido y bien, gana más dinero."
          }, {
            icon: <Users className="w-8 h-8" data-id="element-110" />,
            title: 'FALTA DE EXPERTOS REALES',
            desc: 'Sobran improvisados, pero faltan mecánicos que dominen la técnica integral. Ese lugar vacío es tu oportunidad de oro.'
          }].map((item, idx) => <Card key={idx} className="p-6 hover:-translate-y-1 transition-transform duration-300" data-id="element-111">
                <div className="bg-orange-500/10 w-16 h-16 rounded-full flex items-center justify-center text-orange-500 mb-6 mx-auto" data-id="element-112">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-white mb-3 text-center" data-id="element-113">
                  {item.title}
                </h3>
                <p className="text-slate-400 text-center text-sm leading-relaxed" data-id="element-114">
                  {item.desc}
                </p>
              </Card>)}
          </div>
        </div>
      </section>

      {/* 4. SOLUTION SECTION */}
      <section className="py-20 bg-slate-900 px-4" data-id="element-115">
        <div className="max-w-5xl mx-auto" data-id="element-116">
          {/* Solution image above H2 */}
          <div className="mb-12" data-id="element-117">
            <img src={ASSETS.solutionImage} alt="Moto Logic Pro" className="w-full max-w-3xl mx-auto rounded-xl shadow-2xl border border-slate-800" data-id="element-118" />
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-119">
            <div className="relative" data-id="element-120">
              <div className="absolute inset-0 bg-orange-500/20 blur-[80px] rounded-full" data-id="element-121" />
              <img src={ASSETS.mainProduct} alt="Moto Logic Pro Course" className="relative z-10 w-full rounded-xl shadow-2xl shadow-black/50 transform md:rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-122" />
            </div>
            <div data-id="element-123">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 uppercase" data-id="element-124">
                ¿Qué vas a lograr con{' '}
                <span className="text-orange-500" data-id="element-125">Moto Logic Pro</span>?
              </h2>
              <ul className="space-y-6 mb-10" data-id="element-126">
                {[{
                title: 'MÉTODO DE LÓGICA DE TALLER',
                desc: 'No vas a estudiar de memoria. Vas a entender el funcionamiento real de cada componente para resolver cualquier falla con total precisión.'
              }, {
                title: 'INDEPENDENCIA LABORAL',
                desc: 'Olvidate de los jefes. Manejá tus propios horarios y trabajá desde tu propio garage o espacio disponible.'
              }, {
                title: 'INGRESOS DESDE EL PRIMER MES',
                desc: 'Te enseñamos las reparaciones más buscadas para que recuperes tu inversión casi de inmediato.'
              }, {
                title: 'CRECIMIENTO SIN TECHO',
                desc: 'Empezás con trabajos puntuales y escalás hasta tener tu propio taller reconocido en tu ciudad.'
              }].map((item, idx) => <li key={idx} className="flex gap-4" data-id="element-127">
                    <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-128" />
                    <div data-id="element-129">
                      <h4 className="font-bold text-white text-lg" data-id="element-130">
                        {item.title}
                      </h4>
                      <p className="text-slate-400" data-id="element-131">{item.desc}</p>
                    </div>
                  </li>)}
              </ul>
              <Button size="lg" onClick={scrollToOffer} className="w-full md:w-auto" data-id="element-132">
                QUIERO EMPEZAR MI CAMINO PROFESIONAL
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* 5. BONUSES */}
      <section className="py-20 bg-slate-950 px-4 overflow-hidden" data-id="element-133">
        <div className="max-w-7xl mx-auto" data-id="element-134">
          <h2 className="text-3xl md:text-5xl font-bold text-white text-center mb-16 uppercase" data-id="element-135">
            🎁 Si accedés hoy, te llevás estos{' '}
            <span className="text-orange-500" data-id="element-136">5 Bonus de Regalo</span>:
          </h2>
          <BonusCarousel data-id="element-137" />
        </div>
      </section>

      {/* 6. OFFER SECTION */}
      <section id="offer-section" className="py-20 px-4 relative overflow-hidden" data-id="element-138">
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900 to-black" data-id="element-139" />
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-140">
          <Card className="p-6 md:p-12 text-center border-2 border-blue-500 shadow-[0_0_50px_-12px_rgba(59,130,246,0.5)] bg-slate-900/80 backdrop-blur" data-id="element-141">
            <h2 className="text-2xl md:text-4xl font-black text-white mb-6 uppercase" data-id="element-142">
              🏆 Moto Logic Pro + 5 Bonus de Regalo
            </h2>

            <div className="mb-6 space-y-2" data-id="element-143">
              <p className="text-slate-500 text-xl line-through decoration-red-500 decoration-2" data-id="element-144">
                Valor Regular: $59.900 ARS
              </p>
              <p className="text-yellow-400 font-bold text-sm md:text-base uppercase tracking-wide animate-pulse" data-id="element-145">
                ⚠️ OFERTA VÁLIDA SOLO POR HOY, {currentDate}
              </p>
              <div className="text-5xl md:text-7xl font-black text-[#00FF00] tracking-tight drop-shadow-lg" data-id="element-146">
                $19.990{' '}
                <span className="text-2xl text-slate-400 font-bold" data-id="element-147">ARS</span>
              </div>
              <div className="flex items-center justify-center gap-2 text-yellow-400 font-bold mt-2" data-id="element-148">
                <div className="flex" data-id="element-149">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-current" data-id="element-150" />)}
                </div>
                <span data-id="element-151">4.9/5</span>
              </div>
              <p className="text-slate-400 font-medium mt-4" data-id="element-152">
                (Único pago - Acceso de por vida)
              </p>
            </div>

            {/* Unified counter */}
            <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-slate-800/50 px-4 py-2.5 rounded-full border border-slate-700 mb-6 text-xs md:text-sm font-bold mx-auto max-w-lg" data-id="element-153">
              <span className="flex items-center gap-1.5" data-id="element-154">
                <span className="relative flex h-2.5 w-2.5" data-id="element-155">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-156"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500" data-id="element-157"></span>
                </span>
                <span className="text-white" data-id="element-158">{viewers} viendo ahora</span>
              </span>
              <span className="text-slate-600" data-id="element-159">|</span>
              <span className="flex items-center gap-1.5" data-id="element-160">
                <span className="relative flex h-2.5 w-2.5" data-id="element-161">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-162"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" data-id="element-163"></span>
                </span>
                <span className="text-white" data-id="element-164">Solo {spotsLeft} cupos</span>
              </span>
            </div>

            <Button size="xl" fullWidth className="text-base md:text-xl py-6 shadow-xl shadow-orange-500/20 mb-6" onClick={() => window.location.href = PURCHASE_LINK} data-id="element-165">
              🚀 QUIERO MI ACCESO AHORA
            </Button>

            {/* Payment - Mercado Pago large */}
            <div className="mb-6" data-id="element-166">
              <img src={ASSETS.mercadoPago} alt="Mercado Pago" className="w-[90%] max-w-md mx-auto object-contain mb-4" data-id="element-167" />

              {/* Trust block */}
              <div className="grid grid-cols-2 gap-3 max-w-sm mx-auto bg-[#0A0A0A] rounded-xl border border-blue-500/30 p-3" data-id="element-168">
                <div className="flex flex-col items-center text-center gap-2" data-id="element-169">
                  <img src={ASSETS.compraSegura} alt="Compra Segura" className="h-12 object-contain" data-id="element-170" />
                  <p className="text-green-400 font-bold text-xs uppercase" data-id="element-171">
                    COMPRA SEGURA
                  </p>
                  <p className="text-white/70 text-[10px]" data-id="element-172">
                    Tus datos protegidos
                  </p>
                </div>
                <div className="flex flex-col items-center text-center gap-2" data-id="element-173">
                  <img src={ASSETS.garantia} alt="Garantía 7 Días" className="h-12 object-contain" data-id="element-174" />
                  <p className="text-cyan-400 font-bold text-xs uppercase" data-id="element-175">
                    GARANTÍA 7 DÍAS
                  </p>
                  <p className="text-white/70 text-[10px]" data-id="element-176">
                    Probalo sin riesgo
                  </p>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </section>

      {/* 7. TESTIMONIALS */}
      <section className="py-20 bg-slate-900 px-4" data-id="element-177">
        <div className="max-w-4xl mx-auto" data-id="element-178">
          <div className="text-center mb-10" data-id="element-179">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-2 uppercase" data-id="element-180">
              MÁS DE 3.200 ALUMNOS SATISFECHOS
            </h2>
            <div className="flex items-center justify-center gap-3 text-yellow-400 text-lg font-bold" data-id="element-181">
              <span data-id="element-182">4.9/5 – 1.243 reseñas verificadas</span>
              <div className="flex gap-0.5" data-id="element-183">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-current" data-id="element-184" />)}
              </div>
            </div>
          </div>

          <div className="space-y-4 mb-8" data-id="element-185">
            {ALL_TESTIMONIALS.slice(0, visibleCount).map((testimonial, idx) => <div key={idx} className="bg-slate-800 border border-slate-700 p-5 rounded-xl" data-id="element-186">
                <div className="flex gap-0.5 mb-2" data-id="element-187">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-500 fill-yellow-500" data-id="element-188" />)}
                </div>
                <p className="text-slate-300 italic mb-3" data-id="element-189">
                  "{testimonial.text}"
                </p>
                <p className="font-bold text-white text-sm" data-id="element-190">
                  {testimonial.name}
                </p>
              </div>)}
          </div>

          {visibleCount < ALL_TESTIMONIALS.length && <div className="text-center" data-id="element-191">
              <Button fullWidth onClick={loadMoreComments} data-id="element-192">
                CARGAR 5 COMENTARIOS MÁS
              </Button>
            </div>}

          <ReviewForm data-id="element-193" />
        </div>
      </section>

      {/* 8. FAQ */}
      <FAQSection data-id="element-194" />

      {/* Footer */}
      <footer className="py-8 bg-black text-center text-slate-600 text-sm border-t border-slate-900" data-id="element-195">
        <p data-id="element-196">© 2024 Moto Logic Pro. Todos los derechos reservados.</p>
        <p className="mt-2" data-id="element-197">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}